import { setCookie, getCookieValue } from './cookie';
import {
  getScrollTop, setBannerHeight, stickyHeader,
} from './helpers';

import injectRegistrationScripts, { injectDefaultScripts } from './registrationScripts';
import { showPlansFold } from './utils/registerUtils';


/* Hero Fader ------------------------------------------------------------*/

function fade() {
  const heroHeight = document.querySelector('.hero').clientHeight;
  const winPosition = getScrollTop();
  const winPositionPercent = (winPosition / heroHeight);
  const fadeValue = (0 + winPositionPercent / 2.5);
  const fader = document.getElementById('fader');
  if (fader) {
    fader.style.opacity = fadeValue;
  }
}

function toggleMegaMenu() {
  const navLinks = document.querySelectorAll('.header__nav__left .nav-link');
  if (navLinks) {
    navLinks.forEach((navLink) => {
      const currentNavLink = navLink;
      navLink.addEventListener('mouseover', () => {
        navLinks.forEach((el) => {
          // eslint-disable-next-line no-param-reassign
          el.style.borderColor = 'transparent';
        });
        currentNavLink.style.borderColor = '#2dccd2';
        setTimeout(() => {
          document.querySelector('header').classList.add('mega-menu-pop-up');
          document.body.classList.add('mega-menu-overlay');
        }, 200);

        const targetContent = document.querySelector('.mega-menu.visible');
        if (targetContent) targetContent.classList.remove('visible');
        currentNavLink.parentElement.querySelector('.mega-menu').classList.add('visible');
      });
    });
  }
  document.querySelector('header').addEventListener('mouseleave', () => {
    navLinks.forEach((el) => {
      el.style.borderColor = null; // eslint-disable-line
    });
    setTimeout(() => {
      document.querySelector('header').classList.remove('mega-menu-pop-up');
      document.body.classList.remove('mega-menu-overlay');
    }, 300);
  });
}

/* Mobile Pop-up menu */
function toggleMobileMenu() {
  const mobileMenu = document.querySelector('header .burger-menu');
  if (mobileMenu !== null) {
    mobileMenu.addEventListener('click', () => {
      document.querySelector('header').classList.toggle('menu-pop-up');
      if (document.querySelector('header').classList.contains('menu-pop-up')) {
        document.body.classList.add('overflow-hidden');
      } else { document.body.classList.remove('overflow-hidden'); }
    });
  }
}


function animateLogo() {
  const logo = document.querySelector('.logo');
  if (logo) {
    setTimeout(() => {
      logo.classList.remove('logo-animate');
    }, 2000);
  }
}

function toggleDiscountBanner() {
  const discountBanner = document.getElementById('discountBanner');
  if (discountBanner) {
    document.getElementById('discount-close-btn').addEventListener('click', () => {
      document.querySelector('.discount-banner').classList.remove('show');
      setCookie('isDiscountBannerClosed', true);
    });
    if (getCookieValue('isDiscountBannerClosed')) {
      document.querySelector('.discount-banner').classList.remove('show');
    } else {
      document.querySelector('.discount-banner').classList.add('show');
    }
  }
}

export default function accordionHandler() {
  const accordion = document.querySelectorAll('.js-accordion');
  if (accordion) {
    accordion.forEach((accordionEl) => {
      const accordionToggle = accordionEl.querySelectorAll('.js-accordion-toggle');
      accordionToggle.forEach((el) => {
        el.addEventListener('click', () => {
          const targetItem = el.parentElement;
          const targetContent = targetItem.querySelector('.js-accordion-content');
          if (targetItem.classList.contains('open')) {
            targetItem.classList.remove('open');
            targetContent.style.maxHeight = null;
          } else {
            const accordionOpen = accordionEl.querySelector('li.open');
            if (accordionOpen) {
              accordionOpen.classList.remove('open');
              accordionOpen.querySelector('.js-accordion-content').style.maxHeight = null;
            }
            targetItem.classList.add('open');
            targetContent.style.maxHeight = `${targetContent.scrollHeight}px`;
          }
        });
      });
    });
  }
}

function moveChatWidget() {
  const main = document.querySelector('main');
  if (window.pageYOffset >= document.documentElement.offsetHeight - 60) {
    main.classList.add('dock-chatwidget');
  } else if (document.querySelector('main.dock-chatwidget')) main.classList.remove('dock-chatwidget');
}

const injectRegistrationScriptsOnLoad = () => {
  const pageWithHeroForm = ['/lp/call-answering-services', '/lp/telephone-answering-services', '/lp/virtual-receptionist-services'];

  if (pageWithHeroForm.includes(document.location.pathname)) {
    injectRegistrationScripts();
  }
};

function injectOnView() {
  if (window.pageYOffset >= 300) {
    injectRegistrationScripts();
    injectDefaultScripts();
  }
}

injectOnView();

window.addEventListener('load', () => {
  toggleDiscountBanner();
  setBannerHeight();
  stickyHeader();
  // animateElements();
  animateLogo();
  accordionHandler();

  if (window.innerWidth > 1120) {
    toggleMegaMenu();
  } else {
    toggleMobileMenu();
  }

  if (window.innerWidth > 580) moveChatWidget();

  injectRegistrationScriptsOnLoad();
});

window.addEventListener('scroll', () => {
  stickyHeader();
  // animateElements();
  injectOnView();
  if (document.querySelector('.hero')) fade();
  if (window.innerWidth > 580) setTimeout(moveChatWidget, 100);
});

window.addEventListener('resize', () => {
  setBannerHeight();
  stickyHeader();
  if (window.innerWidth > 1024) {
    document.querySelector('header').classList.remove('menu-pop-up');
    document.body.classList.remove('overflow-hidden');
  }

  if (window.innerWidth > 580) setTimeout(moveChatWidget, 100);
});

window.addEventListener('pageshow', () => {
  if (getCookieValue('isregistered') && getCookieValue('uniquePin')) {
    showPlansFold(getCookieValue('uniquePin'));
  }
});
